import { Controller } from "stimulus";
import { refreshSticky } from "../mixins/sticky_refresh";

export default class extends Controller {
  static targets = ['content', 'triggerText', 'triggerIcon'];

  toggle() {
    $(this.contentTarget).transition("toggle", {
      onComplete: () => {
        const collapsed = this.contentTarget.classList.contains('hidden');
        const selector = collapsed ? '.ui.sticky:not(.sticky-preserve-on-collapse)' : '.ui.sticky';
        refreshSticky(selector);
      }
    });

    if(this.contentTarget.classList.contains('hidden')) {
      this.triggerIconTarget.classList.remove("up")
      this.triggerIconTarget.classList.add("down")
      this.triggerTextTarget.innerText = "Rozwiń"
    } else {
      this.triggerIconTarget.classList.remove("down")
      this.triggerIconTarget.classList.add("up")
      this.triggerTextTarget.innerText = "Zwiń"
    }
  }
}
